import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Slider from "../components/Slider";
import Footer from "../components/Footer";
import HomeBanner from "../components/HomeBanner";
import axios from "axios";

const Search = () => {
        const [searchQuery, setSearchQuery] = useState('');
        const [searchedProducts, setSearchedProducts] = useState([]);
        const [showDropDown, setShowDropDown] = useState(false);

     const handleSearchChange = async (e) => {
        // console.log("start")
        const query = e.target.value;
        setSearchQuery(query);

        const data = { name: query };

        // console.log("if start")
        // console.log("data", data)
        try {
            const response = await axios.post('https://api.welbeing.in/product/search-product/', data);
            //   console.log("response", response.data);
            setSearchedProducts(response.data.data || '');
            // console.log("searchedProduct", response.data.data || 'no data');
            setShowDropDown(true);

        } catch (error) {
            console.error('Error fetching products:', error);
            setSearchedProducts([]);
            setShowDropDown(false);
        }
    };
    return(

       <>
       <div class="top-products-area py-3 ">
       <section class="search-page">
        <div class="container-lg">
         
          <div class="search-box search-box-side mb-10">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              <input class="form-control" type="search" id="search-box" onkeyup="mySearch()" placeholder="Search here..." onChange={handleSearchChange} onFocus={() => setShowDropDown(searchedProducts.length > 0)} />
			   
            </div>
           
          </div>
         
		  <section class="content">
                
				 <ul class="tags tag" id="myItem">
				    {searchedProducts.map((product, index) => (
				
				 <li>
                           <a href={`/singleproduct?id=${product.p_id}`}>{product.item_name}</a>
                        </li>                    
                    ))}
                    
                </ul>
            </section>
        </div>
      </section></div>
       </>
    )
}
export default Search;